export default {
  REGISTERED: 'R',
  NAMED_SIRES: 'N',
  BIRTH_NOTIFIED: 'B'
}
